export const remind = {
  addRemind: "New Maintenance Reminder (New, Submit Supplement)",
  approvalRemind: "Approval Result Reminder",
  cancelRemind: "Withdrew Reminder (Maintenance / Repair Withdrew)",
  closeRemind: "Finished Reminder (Maintenance / Repair Finished)",
  confirmNoLongerRemind:
    "The selected reminders will no longer appear in the list. Are you sure you want to proceed?",
  details: "Details",
  driverLicenseExpiration: "Driver License ",
  driverLicenseExpirationRemind: "Driver License Expiration Reminder",
  driverLicenseExpirationTips: "{0}'s driver license will expire on {1}",
  events: "Events",
  maintenanceApply: "Maintenance Application",
  maintenanceApplyTips:
    "Vehicle {0} requested for maintenance. The maintenance application number is {1} ",
  maintenanceApproval: "Maintenance Approval",
  maintenanceApprovalTips:
    "Maintenance application(s) {1}（{2}）of vehicle {0} ",
  maintenanceCancel: "Maintenance Application Withdrew",
  maintenanceCancelTips:
    "Maintenance application {1} of vehicle {0} is withdrew",
  maintenanceClose: "Maintenance Finished",
  maintenanceCloseTips:
    "Vehicle {0} finished maintenance. The maintenance application number is {1}.",
  maintenanceExpireRemind: "Maintenance Due Reminder",
  maintenanceRemind: "Maintenance Due",
  maintenanceRemindTips: "Next maintenance date of Vehicle {0} is {1}",
  maintenanceRepairRemind: "Maintenance Reminder",
  noLongerRemind: "Ingore",
  receiveRemind: "Receive Reminders",
  reminds: "Reminders",
  remindTimeInAdvance: "Expire less than (Day)",
  dueTimeInAdvance: "Due less than (Day)",
  repairApply: "Repair Application",
  repairApplyTips:
    "Vehicle {0} requested for repair. The repair application number is {1} ",
  repairApproval: "Repair Approval",
  repairApprovalTips: "Repair application(s) {1}（{2}）of vehicle {0} ",
  repairCancel: "Repair Application Withdrew",
  repairCancelTips: "Repair application {1} of vehicle {0} is withdrew",
  repairClose: "Repair finished",
  repairCloseTips:
    "Vehicle {0} finished repair. The repair application number is {1}.",
  time: "Time",
  vehicleCheckExpiration: "Vehicle Inspection Valid Date",
  vehicleCheckExpirationRemind: "Vehicle Inspection Expiration Reminder",
  vehicleCheckExpirationTips: "Vehicle {0}'s inspection will expire on {1}",
};
